import { useEffect, useState } from "react";
import { LineChart, Line, YAxis, ReferenceLine, ResponsiveContainer } from "recharts";
import api from "@/lib/api";

const cache = {};
const COLORS = { stop_loss: "rgb(var(--bt-negative))", trailing_stop: "rgb(var(--bt-negative))", take_profit: "rgb(var(--bt-positive))" };

const load = (symbol, isCrypto) => {
  if (!cache[symbol]) {
    cache[symbol] = api.get(`/${isCrypto ? "crypto" : "stocks"}/${symbol}/history?period=1m`)
      .then(r => (r.data || []).map(d => ({ close: d.close })))
      .catch(() => { delete cache[symbol]; return []; });
  }
  return cache[symbol];
};

export const MiniStopChart = ({ item, orders }) => {
  const [data, setData] = useState([]);
  const isCrypto = item.asset_type === "crypto";
  useEffect(() => { load(item.symbol, isCrypto).then(setData); }, [item.symbol, isCrypto]);

  if (!data.length) return <div className="w-[120px] h-9" data-testid={`mini-chart-${item.symbol}`} />;
  const series = item.current_price ? [...data, { close: item.current_price }] : data;
  const levels = [item.buy_price, ...orders.map(o => o.target_price)];
  const vals = [...series.map(d => d.close), ...levels];
  const lo = Math.min(...vals), hi = Math.max(...vals), pad = (hi - lo) * 0.08 || hi * 0.01;
  const up = series[series.length - 1].close >= series[0].close;
  const nearest = orders.filter(o => o.order_type !== "take_profit")
    .map(o => Math.abs(o.target_price - item.current_price) / item.current_price * 100).sort((a, b) => a - b)[0];

  return (
    <div className="inline-flex flex-col items-end" data-testid={`mini-chart-${item.symbol}`}
      title={`30-day price · entry $${item.buy_price}${orders.map(o => ` · ${o.order_type.replace("_", " ")} $${o.target_price}`).join("")}`}>
      <div className="w-[120px] h-9">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={series} margin={{ top: 2, right: 2, bottom: 2, left: 2 }}>
            <YAxis hide domain={[lo - pad, hi + pad]} />
            <ReferenceLine y={item.buy_price} stroke="rgb(var(--bt-text-tertiary))" strokeDasharray="2 2" strokeWidth={1} />
            {orders.map(o => <ReferenceLine key={o.id} y={o.target_price} stroke={COLORS[o.order_type]} strokeDasharray="4 2" strokeWidth={1.5} />)}
            <Line type="monotone" dataKey="close" dot={false} strokeWidth={1.5} isAnimationActive={false}
              stroke={up !== (item.position_type === "short") ? "rgb(var(--bt-positive))" : "rgb(var(--bt-negative))"} />
          </LineChart>
        </ResponsiveContainer>
      </div>
      {nearest !== undefined && (
        <span className={`font-mono text-[9px] ${nearest < 2 ? "text-bt-negative font-semibold" : "text-bt-text-tertiary"}`} data-testid={`mini-chart-stop-gap-${item.symbol}`}>
          stop {nearest.toFixed(1)}% away
        </span>
      )}
    </div>
  );
};
